module.exports = __webpack_public_path__ + "static/media/buyer-req-workspace-help-1.cf1497a2.svg";